// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  firebase : {
    apiKey: "AIzaSyDn4CH97sW65ECgfSvYr6WeIveEYxBTBLY",
    authDomain: "sportscene-kinectbooth.firebaseapp.com",
    databaseURL: "https://sportscene-kinectbooth.firebaseio.com",
    projectId: "sportscene-kinectbooth",
    storageBucket: "sportscene-kinectbooth.appspot.com",
    messagingSenderId: "624771345500"
  }
};



// WEBPACK FOOTER //
// /Users/makebetter/Documents/sportsceneDash/src/environments/environment.ts